// Suspense fallbacks shown while a lazy route chunk downloads (issue #396).
//
// RouteFallback renders inside the app Layout (header/nav stay visible) as a
// neutral dark-theme page skeleton. FullScreenFallback covers routes that own
// the whole viewport (auth pages, backstage) where no chrome exists yet.

import { Loader2 } from 'lucide-react';
import { PageContainer } from '@/components/PageContainer';
import { Skeleton } from '@/components/ui/skeleton';

export function RouteFallback() {
  return (
    <PageContainer data-testid="route-fallback" aria-busy="true">
      <Skeleton className="h-8 w-44" />
      <div className="mt-6 space-y-3">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-24 w-full" />
      </div>
    </PageContainer>
  );
}

export function FullScreenFallback() {
  return (
    <div
      data-testid="route-fallback-fullscreen"
      aria-busy="true"
      className="min-h-screen bg-background flex items-center justify-center"
    >
      <Loader2 className="size-8 motion-safe:animate-spin text-muted-foreground" aria-hidden="true" />
    </div>
  );
}
